/**
 * Usage Service
 *
 * API service for fetching user usage statistics.
 */

import { apiClient } from "./api";
import type { UserUsage } from "../types/usage";

/**
 * Fetch current user's usage statistics
 */
export async function getUserUsage(): Promise<UserUsage> {
  const response = await apiClient.get<UserUsage>("/api/v1/usage/me");
  return response.data;
}
